export const MenuList = [
  {
    title: "Site Management",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-025-dashboard" />,
    content: [
      {
        title: "Rate Plan",
        to: "/site-management/rate-plan",
        permissions: ["rate_plan:view", "rate_plan:create", "rate_plan:edit", "rate_plan:delete"],
      },
      {
        title: "Country",
        to: "/site-management/country",
        permissions: ["country:view", "country:create", "country:edit", "country:delete"],
      },
      {
        title: "State",
        to: "/site-management/state",
        permissions: ["state:view", "state:create", "state:edit", "state:delete"],
      },
      {
        title: "City",
        to: "/site-management/city",
        permissions: ["city:view", "city:create", "city:edit", "city:delete"],
      },
      {
        title: "Location",
        to: "/site-management/location",
        permissions: ["location:view", "location:create", "location:edit", "location:delete"],
      },
      {
        title: "Payment Type",
        to: "/site-management/payment-type",
        permissions: ["payment_type:view", "payment_type:create", "payment_type:edit", "payment_type:delete"],
      },
      {
        title: "Customer",
        to: "/site-management/customer",
        permissions: ["customer:view", "customer:create", "customer:edit", "customer:delete"],
      },
      {
        title: "Travel Partners",
        to: "/site-management/travel-partners",
        permissions: ["travel_partners:view", "travel_partners:create", "travel_partners:edit", "travel_partners:delete"],
      },
      {
        title: "Commission",
        to: "/site-management/commission",
        permissions: ["commission:view", "commission:create", "commission:edit", "commission:delete"],
      },
      {
        title: "Company Details",
        to: "/site-management/company-details",
        permissions: ["company_details:view", "company_details:create", "company_details:edit", "company_details:delete"],
      },
      {
        title: "Inclusion",
        iconStyle: <i className="flaticon-013-checkmark" />,
        to: "/site-management/inclusion",
        permissions: ["inclusion:view", "inclusion:create", "inclusion:edit", "inclusion:delete"],
      },
    ],
  },
  {
    title: "Hotel Management",
    iconStyle: <i className="flaticon-013-checkmark" />,
    to: "/hotel-management/hotel",
    permissions: ["hotel:view", "hotel:create", "hotel:edit", "hotel:delete"],
  },
  {
    title: "Documents Management",
    iconStyle: <i className="flaticon-013-checkmark" />,
    to: "/document-management/document-list",
    permissions: ["document:view", "document:create", "document:edit", "document:delete"],
  },
  {
    title: "Rate Management",
    iconStyle: <i className="flaticon-013-checkmark" />,
    to: "/rate-management/list",
    permissions: ["rate:view", "rate:create", "rate:edit", "rate:delete"],
  },
  {
    title: 'Reservation Management',
    iconStyle: <i className="fas fa-calendar-check" />,
    to: "/reservation-management/list",
    permissions: ["reservation:view", "reservation:create", "reservation:edit", "reservation:delete", "reservation:cancel"],
  },
  {
    title: 'Payment Management',
    iconStyle: <i className="fas fa-money-bill" />,
    to: "/payment/list",
    permissions: ["payment:view", "payment:create", "payment:edit", "payment:delete"],
  },
  {
    title: 'GST Management',
    iconStyle: <i className="fas fa-file-invoice" />,
    to: "/gst-management/invoices",
    permissions: ["gst:view", "gst:create", "gst:edit", "gst:delete"],
  },
  {
    title: "CRS User Management",
    iconStyle: <i className="fas fa-users" />,
    to: "/crs-user/list",
    permissions: ["crs_users:view", "crs_users:create", "crs_users:edit", "crs_users:delete"],
  },
  {
    title: "Hotel User Management",
    iconStyle: <i className="fas fa-users" />,
    to: "/hotel-user/list",
    permissions: ["hotel_users:view", "hotel_users:create", "hotel_users:edit", "hotel_users:delete"],
  },
  {
    title: 'Expenses Management',
    iconStyle: <i className="fas fa-receipt" />,
    to: "/expenses/list",
    permissions: ["expense:view", "expense:create", "expense:edit", "expense:delete"],
  },
  {
    title: 'Bank Management',
    iconStyle: <i className="fas fa-university" />,
    to: "/bank-management/bank-statements",
    permissions: ["bank:view", "bank:create", "bank:edit", "bank:delete"],
  },
  {
    title: 'Role management',
    iconStyle: <i className="fas fa-cogs" />,
    to: "/role-management/list",
    permissions: ["role:view", "role:create", "role:edit", "role:delete"],
  },
  {
    title: "OTA Management",
    iconStyle: <i className="fas fa-globe" />,
    to: "/ota-management/list",
    permissions: ["ota:view", "ota:create", "ota:edit", "ota:delete"],
  },
  {
    title: "Inquiry Management",
    iconStyle: <i className="fas fa-question-circle" />,
    to: "/inquiry-management/list",
    permissions: ["inquiry:view", "inquiry:create", "inquiry:edit", "inquiry:delete"],
  },
  {
    title: 'Hotels Invoice Management',
    iconStyle: <i className="fas fa-file-invoice" />,
    to: "/hotel-invoices/list",
    permissions: ["hotel_invoices:view", "hotel_invoices:create", "hotel_invoices:edit", "hotel_invoices:delete"],
  },
  // {
  //   title: 'Reports Management  ',
  //   classsChange: 'mm-collapse',
  //   iconStyle: <i className="fas fa-calendar-check" />,
  //   content: [
  //     {
  //       title: 'Reports list',
  //       to: 'reports/list',
  //     },
  //     {
  //       title: 'Create Reports',
  //       to: 'reports/create',
  //     },
  //   ],
  // },
]
